import React from 'react';
import { observer, inject } from 'mobx-react';
import { AppLocaleProvider } from 'sd-ui-components';
import FormattedDate from '../Common/FormattedDate';
import './EventContent';

const { FormattedMessage } = AppLocaleProvider;

@inject('ConfigStore')
@observer
class EventSummary extends React.Component {
  render() {
    const { event } = this.props;

    if (!event) {
      return null;
    }

    return (
      <table className="event-details-header-table">
        <tbody>
          <tr>
            <td>
              <h2 className="event-details-event-number">
                {event.eventNumber}
              </h2>
              <span className="event-details-label">
                <FormattedMessage
                  id="App.EventDetails.Recorded"
                  defaultMessage="Recorded"
                />{' '}
              </span>
              <span className="event-details-text">
                <FormattedDate
                  value={event.recordedOn}
                  day="2-digit"
                  month="2-digit"
                  hour="numeric"
                  minute="numeric"
                  timeZoneName="short"
                  timeZone={
                    (event.site && event.site.siteIanaTimezone) ||
                    this.props.ConfigStore.config.standardizedTimezone
                  }
                />
              </span>
            </td>
            <td>
              <div className="event-details-score-circle-div sd-primary-color-4-background">
                <h2
                  className={`event-details-score-number ${
                    String(event.safetyScore || 0).length > 3
                      ? 'long-score'
                      : ''
                  }`}
                >
                  {event.safetyScore}
                </h2>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

export default EventSummary;



// WEBPACK FOOTER //
// ./src/containers/EventDetails/EventSummary.jsx